module.exports = __webpack_public_path__ + "static/media/search-results.998d3f94.svg";